import React from 'react';
import {Modal, Row, Col} from "antd";
import 'antd/lib/modal/style/css';
import languages from "../../language/languages";
import getCertificateInfo from "../../actions/getCertificateInfo";
import getStatus from "../../helpers/getStatus";
import modalShow from "../../actions/modalShow";
import modalDismiss from "../../actions/modalDismiss";
import {connect} from "react-redux";
import {P12_MODAL} from "./types";

class CertDetailsModal extends React.Component {

    componentDidMount()
    {
        this.props.getCertificateInfo({certid:this.props.record.certid});
    }

    renderCustomFields=(customFields)=>
    {
        return customFields.map(customField=>{
            let label=customField.label;
            return <Row>
                <Col xs={12} md={12}>
                    <strong>{label&& label!==''?JSON.parse(label)[this.props.language]:''}</strong>
                </Col>
                <Col xs={12} md={12}>
                    {customField.customValue}
                </Col>
            </Row>;
        });
    };
    genP12Cert = (certid, referenceNumber,authCode) =>
    {
        let general=this;
        let message=languages[this.props.language].p12PasswordModalMessage;
        this.props.modalDismiss();
        this.props.modalShow({
            modalType: P12_MODAL,
            modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
            componentProps: {dispatch:this.props.dispatch,onOK:(pass) =>{general.props.modalDismiss();general.props.onOK({userAlias:certid,password:pass,confirmPassword:pass,referenceNumber:referenceNumber,authCode:authCode});},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
        });
    };


    render() {
        let certInfo=this.props.certificateInfo;
        if(!certInfo)
            return '';
        let status=certInfo.status;
        const currentStatus=getStatus(this.props.language,this.props.isRA).find(x => x.code === status);
        let statusName=status;
        if(currentStatus)
            statusName=currentStatus.name;
        let authCode=status==='PENDING'|| this.props.isRA?certInfo.authCode:'';
        let referenceNumber=status==='PENDING'|| this.props.isRA?certInfo.referenceNumber:'';
        let p12Button=status==='PENDING'?<p className={'link'} onClick={() => this.genP12Cert(certInfo.certid,referenceNumber,authCode)}>{languages[this.props.language].generateCertP12}</p>:'';
        return (
            <Modal centered visible={this.props.modalType !== null} {...this.props.modalProps}>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].serialNumber}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.certid}
                    </Col>

                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].cn}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.cn}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].cedula}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.cedula}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].email}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.email}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].telefono}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.phone}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].statusLabel}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {statusName}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].type}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.type}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].dateLabel}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.date}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].notAfterLabel}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.notAfter}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].issuedDateLabel}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.issueDate}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].country}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.pais}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].direccion}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.direccion}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].state}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.estado}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].city}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.ciudad}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].organization}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.empresa}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].organizationalUnit}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        {certInfo.departamento}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].referenceNumberLabel}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        <div>{referenceNumber}</div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <strong>{languages[this.props.language].authCodeLabel}</strong>
                    </Col>
                    <Col xs={12} md={12}>
                        <div>{authCode}</div>
                    </Col>
                </Row>
                {this.renderCustomFields(certInfo.customFields)}
                {p12Button}
            </Modal>
        )
    }

}

function mapStateToProps(state) {
    return {
        language: state.auth.language,
        certificateInfo:state.certificates.certificateInfo,
        isRA:state.auth.isRA
    }
}

export default connect(mapStateToProps, {getStatus,getCertificateInfo,modalShow,modalDismiss})(CertDetailsModal);